<template>
    <div class="all">
      <Head></Head>
      <div class="jifen">
        <IntegralExchange></IntegralExchange>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import IntegralExchange from './IntegralExchange'
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
    export default {
        name: "jifen",
      components:{
        Pagetail,Head,IntegralExchange
      }
    }
</script>

<style scoped lang="less">
  .jifen{
    width: 1200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/jifen.vue